<script setup lang="ts">
type PillOption = {
  value: string
  label: string
  badge?: string | number
}

defineProps<{
  options: PillOption[]
}>()

const model = defineModel<string>({ required: true })

const isActive = (pill: PillOption) => model.value === pill.value

const pillClass =
  'border-line bg-surface text-ink-3 inline-flex min-h-12 items-center gap-4 rounded-full border px-8 shadow-card transition hover:border-success-200 hover:bg-success-50 hover:text-success-800'
const pillActiveClass = 'border-success-800! bg-success-50! text-success-800!'

const badgeClass = 'bg-surface-3 text-ink-3 inline-flex size-6 items-center justify-center rounded-full'
const badgeActiveClass = 'bg-success-800! text-white!'
</script>

<template>
  <div class="flex flex-wrap gap-4">
    <button
      v-for="pill in options"
      :key="pill.value"
      type="button"
      :aria-pressed="isActive(pill)"
      :class="[pillClass, isActive(pill) ? pillActiveClass : '']"
      @click="model = pill.value">
      <span v-if="pill.badge !== undefined" :class="[badgeClass, isActive(pill) ? badgeActiveClass : '']">
        {{ pill.badge }}
      </span>
      <span>{{ pill.label }}</span>
    </button>
  </div>
</template>
